import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function oneOf<T>(allowedValues: T[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const allowed = allowedValues.includes(control.value);
        return allowed ? null : { forbiddenName: { value: control.value } };
    };
}
